/** Response shape for GET /notification-preferences */
export interface NotificationPreferencesResponse {
  connectionRequestEmails: boolean;
  directMessageEmails: boolean;
}

/** Partial update for PUT /notification-preferences */
export interface UpdateNotificationPreferencesRequest {
  connectionRequestEmails?: boolean;
  directMessageEmails?: boolean;
}

/** Default preference values (opt-in by default) */
export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferencesResponse =
  {
    connectionRequestEmails: true,
    directMessageEmails: true,
  };
